import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { GroupService } from '../../services/group/group.service';
import { SiteService } from '../../services/site/site.service';
import { ZoneService } from '../../services/zone/zone.service';
import { BrandService } from '../../services/brand/brand.service';
import { CommonService } from '../../services/common/common.service';
import { WidgetService } from '../../services/widget/widget.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Country } from '../../interface/country';
import { map, pairwise, startWith, takeUntil } from 'rxjs/operators';
import { Observable, ReplaySubject } from 'rxjs';
import { DeviceService } from '../../services';

@Component({
  selector: 'group-filter',
  templateUrl: './group-filter.component.html',
  styleUrls: ['./group-filter.component.scss']
})
export class GroupFilterComponent implements OnInit, OnDestroy {
  @ViewChild('searchCountry') searchCountry: ElementRef;
  private _unsubscribeAll  : ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  openFilter: boolean = false;
  geoData: boolean = false;
  geoSitesLoaded: boolean = false;
  nonSitesLoaded: boolean = false;
  groupName: string = "";
  filterForm: FormGroup;
  siteList = [];
  selectedSites = [];
  zoneList = [];
  brandList = [];
  deviceList = [];
  specificList = [];
  dashboardId: string;
  groupId: string;
  isSubmitted: number = 0;
  consolidateDataLabel = "Site";
  grpTopOffset: number = 0;
  countryList: Country[] = [];
  searchCountryControl = new FormControl('');
  filteredCountry: Observable<Country[]>;
  selectedCountry = [];

  constructor(
    private groupService: GroupService,
    private siteService: SiteService,
    private deviceService: DeviceService,
    private zoneService: ZoneService,
    private widgetService: WidgetService,
    private brandService: BrandService,
    public fb: FormBuilder,
    private commonService: CommonService,
    public router: Router,
    public activatedRoute: ActivatedRoute
  ) {
    this.groupService.getAction().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      if (['openFilter'].includes(res.action)) {
        this.openFilter = true;
        this.groupName = res.data.groupName;
        this.groupId = res.data._id;
        this.setFormValue(res.data);
        this.selectedCountry = [...res.data.countryId || ""];
        this.showSpecific();
        this.geoData = res.data.isGeo;
        if (this.geoData && !this.geoSitesLoaded) {
          this.siteService.listGeoSites().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
            this.siteList = res;
            let fullSites = ['full'];
            this.siteList.forEach((v, i) => {
              fullSites.push(v._id);
            });
            if (this.filterForm.value.sites.length == 0 || this.filterForm.value.sites.includes('full')) {
              this.filterForm.patchValue({
                sites: fullSites
              });
            }
            if (res.length > 0)
              this.geoSitesLoaded = true;
          });
        } else if (!this.geoData && !this.nonSitesLoaded) {
          if (this.filterForm.value.filterFor == "sites") {
            // this.siteService.list("fields=siteName").subscribe(res => {
            //   this.siteList = res;
            //   let fullSites = ['full'];
            //   this.siteList.forEach((v, i) => {
            //     fullSites.push(v._id);
            //   });
            //   if (this.filterForm.value.sites.length == 0 || this.filterForm.value.sites.includes('full')) {
            //     this.filterForm.patchValue({
            //       sites: fullSites
            //     });
            //   }
            //   if (res.length > 0)
            //     this.nonSitesLoaded = true;
            // });
          }
        }
        //this will be used for group sections where we find offset of grp id and set the filter beside them
        $('.group-filter').hide();
        let topOffset = $('#' + this.groupId).offset().top;
        topOffset = topOffset - 124;
        this.grpTopOffset = parseInt(topOffset.toString());
        $('.group-filter').show();
      }
      if (['closeFilter'].includes(res.action)) {
        this.closeFilter();
      }
    });

    this.siteService.countryList().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.countryList = res;
    })

    this.createForm();
  }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this._unsubscribeAll)).subscribe((params: Params) => {
      this.dashboardId = params['id'];
    })

    this.filteredCountry = this.searchCountryControl.valueChanges.pipe(startWith<string>(''), map(name => this.filterCountry(name)));
  }

  ngOnDestroy() {
    this.selectedCountry = [];
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }

  createForm() {
    this.filterForm = this.fb.group({
      groupId: "",
      filterFor: "",
      sites: [],
      zones: [],
      brands: [],
      mappedFullSite: "",
      showDataByOperationalHours: "",
      dateType: "",
      from: "",
      to: "",
      tdFrom: "",
      groupByTimeFrame: "",
      showSpecificDate: [],
      consolidateSiteData: "",
      consolidateData: 1,
      consolidateDate: 0,
      showTrend: 0,
      trendFrom: "",
      refreshGroup: 0,
      showSelection: false,
      countryId: [],
      devices: []
    })


    this.filterForm.get('filterFor').valueChanges.pipe(pairwise()).pipe(takeUntil(this._unsubscribeAll)).subscribe(([prev, next]: [string, string]) => {
      if (next == "sites" && prev != next) {
        this.filterForm.get('brands').patchValue([]);
        this.filterForm.get('countryId').patchValue([]);
        this.filterForm.get('sites').patchValue([]);
        this.setSiteList(this.filterForm.value.brands, this.filterForm.value.countryId);
        this.selectedCountry = [];
      }
      if (next == "brands" && prev != next) {
        this.filterForm.get('sites').patchValue([]);
        this.filterForm.get('countryId').patchValue([]);
        this.setSiteList(this.filterForm.value.brands, this.filterForm.value.countryId);
        this.getBrandsList();
        this.selectedCountry = [];
      }
    })
  }

  setConsolidateDataLabel() {
    //setting a lebel for consolidated Site Data
    if (this.filterForm.controls["filterFor"].value == "sites") {
      if (this.filterForm.controls["mappedFullSite"].value == 1) {
        this.consolidateDataLabel = "Site";
      }else if(this.filterForm.controls["mappedFullSite"].value == 2) {
        this.consolidateDataLabel = "Device";
      } else {
        this.consolidateDataLabel = "Zone";
      }
    } else {
      this.consolidateDataLabel = "Brand";
    }
  }

  setFormValue(group) {
    let filterFor = "";
    let tdFrom;
    if (group.sites.length > 0 && group.sites.length != 0 && !group.countryId) {
      filterFor = "sites";
    } else if (group.brands.length > 0) {
      filterFor = "brands";
    } else {
      filterFor = "sites";
    }
    if (!group.refreshGroup) {
      group.refreshGroup = 0;
    }

    //for mtd, wtd and ytd it will have blank value
    if (group.to == "") {
      group.to = new Date();
    }

    //ripun
    let fromDate = this.commonService.getOffsetConvertedSite(group.from, "YYYY-MM-DD HH:mm:ss");
    let toDate = this.commonService.getOffsetConvertedSite(group.to, "YYYY-MM-DD HH:mm:ss");

    // let fromDate = this.commonService.parseToDbDateStartOfTheDay(group.from);
    // let toDate = this.commonService.parseToDbDateEndOfTheDay(group.to);

    //trend date        
    let trendDate = this.commonService.getOffsetConvertedSite(group.trendFrom, "YYYY-MM-DD HH:mm:ss");
    // let trendDate = this.commonService.parseToDbDateStartOfTheDay(group.trendFrom);


    tdFrom = ["MTD", "YTD", "WTD"].includes(group.dateType) ? toDate : new Date().toDateString();//this.commonService.getOffsetConverted(new Date().toDateString(),"YYYY-MM-DD HH:mm:ss",false);
    // console.log("tdFrom ",tdFrom );
    // console.log("fromDate ",fromDate," toDate :",toDate);
    //convert UTC to Local
    // let fromDate = this.commonService.getUTCToLocalDate(new Date(group.from));
    // let toDate = this.commonService.getUTCToLocalDate(new Date(group.to));    

    this.filterForm.patchValue({
      groupId: group._id,
      filterFor: filterFor,
      mappedFullSite: group.mappedFullSite,
      showDataByOperationalHours: group.showDataByOperationalHours,
      dateType: group.dateType,
      from: fromDate,
      to: toDate,
      tdFrom: tdFrom,
      groupByTimeFrame: group.groupByTimeFrame,
      showSpecificDate: group.showSpecificDate,
      sites: group.sites,
      brands: group.brands,
      zones: group.zones,
      consolidateSiteData: group.consolidateSiteData,
      consolidateData: group.consolidateData,
      consolidateDate: group.consolidateDate || 0,
      showTrend: group.showTrend,
      trendFrom: trendDate,
      refreshGroup: group.refreshGroup,
      showSelection: group.showSelection || false,
      countryId: group.countryId || [],
      devices: group.devices || []
    });
    this.selectFullSites(group);
    this.setConsolidateDataLabel();

    //load zones
    this.getZoneList(group.sites, group.mappedFullSite, 0)
    this.setSiteList(group.brands, group.countryId)
    this.getDeviceList(group.sites, group.mappedFullSite)
    if (filterFor == "brands")
      this.getBrandsList()
  }

  selectFullSites(group) {
    if (this.siteList.length <= 0) {
      if (group.isGeo)
        this.geoSitesLoaded = false;
      else
        this.nonSitesLoaded = false;
    } else {
      //if full site is available select all the sites
      if (group.sites.includes('full')) {
        let fullSites = ['full'];
        this.siteList.forEach((v, i) => {
          fullSites.push(v._id);
        });
        this.filterForm.patchValue({
          sites: fullSites
        })
      }
    }
  }

  selectFullShowSpecificdate(isAllSelected = 1) {
    let val = this.filterForm.controls['showSpecificDate'].value;
    let all = [];

    //if full site is available select all the sites
    if (isAllSelected == 0 && val && val.length > 0 && val[0] == "all") {
      all = val;
      all.shift();
    } else if (isAllSelected == 1 && val && val.length > 0 && val[0] == "all") {
      all = ['all'];
      this.specificList.forEach((v, i) => {
        all.push(v.value);
      });
    } else if (isAllSelected == 0 && val && val.length > 0 && val[0] != "all") {
      all = val;
    } else {
      //keep it blank
    }


    this.filterForm.patchValue({
      showSpecificDate: all
    })
  }

  onSubmit(filterForm) {
    this.isSubmitted = 1;
    //get the date
    let dateType = filterForm.dateType;
    let dateObj = { firstDay: "", lastDay: "" };
    let tempFrom = "";
    let tempTo = "";
    tempFrom = (typeof filterForm.from == 'object' && filterForm.from ? filterForm.from._d : filterForm.from);
    tempTo = (typeof filterForm.to == 'object' && filterForm.to ? filterForm.to._d : filterForm.to);

    if (['MTD', 'YTD', 'WTD'].includes(dateType)) {
      tempFrom = "";
      tempTo = (typeof filterForm.tdFrom == 'object' && filterForm.tdFrom ? filterForm.tdFrom._d : filterForm.tdFrom);
    }
    //ripun
    // if (dateType != 'Custom') {
    //   dateObj = this.commonService.convertDate(dateType, tempFrom, tempTo);      
    //   filterForm.from = dateObj.firstDay;//dateObj.firstDay;
    //   filterForm.to = dateObj.lastDay;//dateObj.lastDay;
    // }
    // else {
    //   filterForm.from = this.commonService.parseToDbDateStartOfTheDay(tempFrom);
    //   filterForm.to = this.commonService.parseToDbDateEndOfTheDay(tempTo);
    // }
    if (['MTD', 'YTD', 'WTD'].includes(dateType)) {
      if (!tempTo) {
        tempTo = new Date().toDateString();
      }
    }
    if (tempFrom && dateType == 'Custom' && Object.prototype.toString.call(tempFrom) != '[object Date]')
      tempFrom = tempFrom.replace(' ', 'T');
    if (tempTo && dateType == 'Custom' && Object.prototype.toString.call(tempTo) != '[object Date]')
      tempTo = tempTo.replace(' ', 'T');
    dateObj = this.commonService.convertDate(dateType, tempFrom, tempTo,0);
    filterForm.from = dateObj.firstDay;//dateObj.firstDay;
    filterForm.to = dateObj.lastDay;//dateObj.lastDay;
    //blank to or from date if MTD, YTD or WTD is set
    //until user has not changed value
    if ((this.commonService.isToday(filterForm.tdFrom) || filterForm.tdFrom == null) && ['WTD', 'MTD', 'YTD',].includes(dateType)) { //, 'WTD'
      filterForm.from = "";
      filterForm.to = "";
    }

    //remove tdFrom
    delete filterForm.tdFrom;

    //set trend date
    filterForm.trendFrom = filterForm.showTrend ? filterForm.trendFrom : "";

    //check filterfor is of sites or brands
    if (filterForm.filterFor == 'sites') {
      filterForm.brands = [];
      // filterForm.countryId = [];
      if (filterForm.sites.length < 1) {
        this.commonService.openSnackBar('Please select atleast one site', '');
        this.isSubmitted = 0;
        return false;
      }
    } else {
      // filterForm.sites = [];
      filterForm.mappedFullSite = 1;
      if (filterForm.brands.length < 1) {
        this.commonService.openSnackBar('Please select atleast one brand', '');
        this.isSubmitted = 0;
        return false;
      }
    }

    //send full if fullsite is selected - temp commented
    this.selectedSites = filterForm.sites;
    if (filterForm.sites.length > 0 && filterForm.sites.includes('full')) {
      if (filterForm.brands.length > 0 && filterForm.sites.includes('full')) {
        filterForm.sites = filterForm.sites;
      }
      // else {
      //   filterForm.sites = ['full'];
      // }
    }

    filterForm.brands = filterForm.brands.filter(x => x != 'full') || [];
    filterForm.sites = filterForm.sites.filter(x => x != 'full') || [];
    filterForm.devices = filterForm.devices.filter(x => x != 'full') || [];

    //make mappedfullsite to 1 if zone array lenght is 0
    if (filterForm.mappedFullSite == 0 && filterForm.zones.length < 1) {
      filterForm.mappedFullSite = 1;
    }

    if (filterForm.mappedFullSite == 2 && filterForm.devices.length < 1) {
      filterForm.mappedFullSite = 1;
    }

    //create empty array of zone if mappedFullSite is true
    if (filterForm.mappedFullSite == 1) {
      filterForm.zones = [];
      filterForm.devices = [];
    }else if(filterForm.mappedFullSite == 2){
      filterForm.zones = [];
    }else{
      filterForm.devices = [];
    }

    //convert consolidate data value
    filterForm.consolidateSiteData = (filterForm.consolidateSiteData ? 1 : 0);
    filterForm.consolidateData = (filterForm.consolidateData ? 1 : 0);
    filterForm.consolidateDate = (filterForm.hasOwnProperty('consolidateDate') ? (filterForm.consolidateDate ? 1 : 0) : 0);

    //convert trend data value
    filterForm.showTrend = (filterForm.showTrend ? 1 : 0);
    //set the date in trendFrom
    if (filterForm.showTrend) {
      tempFrom = "";
      tempFrom = (typeof filterForm.trendFrom == 'object' ? filterForm.trendFrom._d : filterForm.trendFrom);
      tempFrom = this.commonService.getDateConverted(tempFrom, "YYYY-MM-DD HH:mm:ss");
      filterForm.trendFrom = tempFrom;
    }
    // filterForm.from = this.commonService.parseToDbDateStartOfTheDay(filterForm.from);
    // filterForm.to = this.commonService.parseToDbDateEndOfTheDay(filterForm.to);
    this.groupService.filter(filterForm, this.dashboardId).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.isSubmitted = 0;
      this.closeFilter();
      //filterForm.sites = this.selectedSites;
      this.widgetService.sendAction("reApplyGroupFilter", filterForm);
    }, (err) => {
      this.isSubmitted = 0;
    })
    // console.log(filterForm);
  }

  getZoneList(sites, mappedFullSite, checkFull = 1) {
    if (mappedFullSite == 0) {
      sites = sites.includes('full') ? this.siteList.map(s => s._id) : sites
      let filter = "fields=siteName,siteId,zoneName,mapped";
      sites.forEach((siteId, i) => {
        filter += "&where[siteId][]=" + siteId;
      });
      this.zoneService.list(filter).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
        this.zoneList = res;
        this.zoneList = this.zoneList.filter(z => z.zoneName != "Master Zone");
        let fullSites = ['full'];
        this.zoneList.forEach((v, i) => {
          fullSites.push(v.siteId + '|' + v._id);
        });
        if (this.filterForm.value.zones.length == 0 || this.filterForm.value.zones.includes('full')) {
          this.filterForm.patchValue({
            zones: fullSites
          });
        }
      })
    }
    if (checkFull) {
      this.checkIsFullSelected(sites);
    }
  }

  checkIsFullSelected(sites) {
    if (sites.includes('full')) {
      sites = sites.filter(site => site !== 'full');
      if (sites.length != this.siteList.length) {
        this.filterForm.patchValue({
          sites: sites
        })
      }
    } else {
      if (sites.length == this.siteList.length) {
        sites.push('full');
        this.filterForm.patchValue({
          sites: sites
        })
      }
    }
  }

  checkIsFullZoneSelected(zones) {
    if (zones.includes('full')) {
      zones = zones.filter(site => site !== 'full');
      if (zones.length != this.zoneList.length) {
        this.filterForm.patchValue({
          zones: zones
        })
      }
    } else {
      if (zones.length == this.zoneList.length) {
        zones.push('full');
        this.filterForm.patchValue({
          zones: zones
        })
      }
    }
  }

  checkIsFullDeviceSelected(devices) {
    if (devices.includes('full')) {
      devices = devices.filter(site => site !== 'full');
      if (devices.length != this.deviceList.length) {
        this.filterForm.patchValue({
          devices:devices
        })
      }
    } else {
      if (devices.length == this.deviceList.length) {
        devices.push('full');
        this.filterForm.patchValue({
          devices: devices
        })
      }
    }
  }

  toggleCheckBox(sites) {
    if (sites.includes('full')) {
      this.filterForm.patchValue({
        sites: ['full']
      })
    } else {
      let fullSites = ['full'];
      this.siteList.forEach((v, i) => {
        fullSites.push(v._id);
      });
      this.filterForm.patchValue({
        sites: fullSites
      })
    }
  }

  toggleDeviceCheckBox(devices) {
    if (devices.includes('full')) {
      this.filterForm.patchValue({
        devices: ['full']
      })
    } else {
      let fullDevices = ['full'];
      this.deviceList.forEach((v, i) => {
        fullDevices.push(v.siteId + '|' + v._id);
      });
      this.filterForm.patchValue({
        devices: fullDevices
      })
    }
  }

  toggleZoneCheckBox(zones) {
    if (zones.includes('full')) {
      this.filterForm.patchValue({
        zones: ['full']
      })
    } else {
      let fullZones = ['full'];
      this.zoneList.forEach((v, i) => {
        fullZones.push(v.siteId + '|' + v._id);
      });
      this.filterForm.patchValue({
        zones: fullZones
      })
    }
  }


  closeFilter() {
    this.openFilter = false;
  }

  showSpecificChange() {
    this.filterForm.get("showSpecificDate").patchValue([]);
    this.showSpecific();
  }

  onShowDataChange() {
    if (this.filterForm.get("groupByTimeFrame").value == "hour")
      this.showSpecificChange();
  }

  //show data for specific or selected filter.
  showSpecific() {
    let tf = this.filterForm.get("groupByTimeFrame").value;
    this.specificList = [];
    if (tf == "hour") {
      for (var i = 0; i <= 23; i++) {
        this.specificList.push({
          value: (i < 10 ? "0" : "") + i + ":00",
          text: (i < 10 ? "0" : "") + i + ":00",
          isSelected: false
        });
      }
    }
    else if (tf == "dayOfWeek") {
      let weekDays: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
      weekDays.forEach((v, i) => {
        this.specificList.push({
          value: (i + 1),
          text: v,
          isSelected: false
        });
      });
    }
    else if (tf == "dayOfMonth") {
      let dateType = this.filterForm.get("dateType").value;
      let dateObj = { firstDay: "", lastDay: "" };
      let tempFrom = "";
      let tempTo = "";
      tempFrom = (typeof this.filterForm.get("from").value == 'object' ? this.filterForm.get("from").value._d : this.filterForm.get("from").value);
      tempTo = (typeof this.filterForm.get("to").value == 'object' ? this.filterForm.get("to").value._d : this.filterForm.get("to").value);
      dateObj = this.commonService.convertDate(dateType, tempFrom, tempTo, 0);
      let from = new Date(dateObj.firstDay);
      let to = new Date(dateObj.lastDay);

      while (from <= to) {
        this.specificList.push({
          value: this.commonService.getMDYDate(from),
          text: this.commonService.getMDYDate(from),
          isSelected: false
        });
        from.setDate(from.getDate() + 1);
      }
    }
    else if (tf == "week") {
      for (var i = 0; i <= 53; i++) {
        this.specificList.push({
          value: i,
          text: "week " + i,
          isSelected: false
        });
      }
    }
    else if (tf == "month") {
      let month: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      month.forEach((v, i) => {
        this.specificList.push({
          value: (i + 1),
          text: v,
          isSelected: false
        });
      });
    }
    else if (tf == "year") {
      let d = new Date().getFullYear();
      let s = d - 10;
      for (var i = s; i <= d; i++) {
        this.specificList.push({
          value: i,
          text: i,
          isSelected: false
        });
      }
    }
  }

  setSiteList(brands = [], country = []) {
    let type = +(this.filterForm.value.filterFor == "sites")
    let filter = "";
    filter += "type=" + type;
    brands && brands.forEach((b) => {
      filter += "&where[brandId][]=" + b;
    })
    country && country.forEach((c) => {
      filter += "&where[countryId][]=" + c;
    })
    this.siteService.getSiteList(filter).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.siteList = res;
      let fullSites = [];
      this.siteList.forEach((v, i) => {
        fullSites.push(v._id);
      });
      if (this.filterForm.value.sites.length == res.length || this.filterForm.value.sites.length == 0 || this.filterForm.value.sites.includes('full'))
        fullSites.push('full');
      if (this.filterForm.value.sites.length == 0 || fullSites.includes('full')) {
        this.filterForm.patchValue({
          sites: fullSites
        });
      }
    });
  }

  getDeviceList(sites=[],mappedFullSite){
    if (mappedFullSite == 2) {
      sites = sites.includes('full') ? this.siteList.map(s => s._id) : sites;
      let filter = "";
      sites && sites.forEach((s) => {
        if(s != "full"){
          filter += "&where[siteId][]=" + s;
        }
      })
      this.deviceService.getDeviceList(filter).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
        this.deviceList = res;
        let fullDevices = [];
        this.deviceList.forEach((v, i) => {
          fullDevices.push(v.siteId + '|' + v._id);
        });
        if (this.filterForm.value.devices.length == res.length || this.filterForm.value.devices.length == 0 || this.filterForm.value.devices.includes('full'))
          fullDevices.push('full');
        if (this.filterForm.value.devices.length == 0 || fullDevices.includes('full')) {
          this.filterForm.patchValue({
            devices: fullDevices
          });
        }
      })
    }
  }

  selectFullBrands(brands) {
    if (brands.includes('full')) {
      this.filterForm.patchValue({
        brands: []
      })
    } else {
      let fullBrands = ['full'];
      this.brandList.forEach((v, i) => {
        fullBrands.push(v._id);
      });
      this.filterForm.patchValue({
        brands: fullBrands
      })
    }
  }

  checkIsFullBrandsSelected(brands) {
    if (brands.includes('full')) {
      brands = brands.filter(site => site !== 'full');
      if (brands.length != this.brandList.length) {
        this.filterForm.patchValue({
          brands: brands
        });
      }
    } else {
      if (brands.length == this.brandList.length) {
        brands.push('full');
        this.filterForm.patchValue({
          brands: brands
        });
      }
    }
  }

  getBrandsList() {
    this.brandService.list().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.brandList = res;
      let fullbrands = [];
      this.brandList.forEach((v, i) => {
        fullbrands.push(v._id);
      });
      if (this.filterForm.value.brands.length == res.length || this.filterForm.value.brands.length == 0 || this.filterForm.value.brands.includes('full'))
        fullbrands.push('full');
      if (this.filterForm.value.brands.length == 0 || fullbrands.includes('full')) {
        this.filterForm.patchValue({
          brands: fullbrands
        });
      }
    })
  }

  clearSearch(e: any) {
    e.stopPropagation();
    this.searchCountryControl.patchValue('');
  }

  filterCountry(value: string): Country[] {
    let filteredList = this.countryList.filter((c) => c.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
    return filteredList;
  }

  openedChange(isOpen: boolean) {
    if (isOpen) {
      this.searchCountry.nativeElement.focus();
    }
    else {
      this.searchCountryControl.patchValue('');
    }
  }

  selectionCountryChange(event) {
    if (event.selected == false) {
      let index = this.selectedCountry.indexOf(event.value);
      this.selectedCountry.splice(index, 1);
      this.filterForm.patchValue({
        countryId: this.selectedCountry
      });
    }
    else {
      this.selectedCountry = [...this.selectedCountry, event.value];
      this.selectedCountry = this.selectedCountry.filter(function (i, p, s) {
        return s.indexOf(i) == p;
      })
      this.filterForm.patchValue({
        countryId: this.selectedCountry
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/directives/group-filter/group-filter.component.ts